'use client';

import { Dropdown, Space } from 'antd';
import { useUserContext } from 'context/user_state';
import { FC } from 'react';
import { Preset } from 'types/enums';
import { getUserImageSource } from 'utils/helpers';
import styles from './index.module.scss';

import ExitRedSvg from 'components/svg/ExitRedSvg';
import FaceAlienSvg from 'components/svg/FaceAlienSvg';
import ProfileSvg from 'components/svg/ProfileSvg';
import SettingSvg from 'components/svg/SettingSvg';
import Avatar from 'components/ui/Avatar';
import { useTranslations } from 'next-intl';
import DropdownPlatform from './DropdownPlatform';
import SelectItem from './SelectItem';

const Profile: FC = () => {
  const userContext = useUserContext();
  const { logout } = useUserContext();
  const t = useTranslations();
  const profileType = userContext.currentProfile?.profileType;

  const menuItems = [
    {
      key: 'profile',
      element: <SelectItem icon={<ProfileSvg />} text={t('profile_header')} href='/personal/my' />,
    },
    {
      key: 'settings',
      element: <SelectItem icon={<SettingSvg />} text={t('settings')} href='/settings' />,
    },
    {
      key: 'character',
      element: (
        <SelectItem icon={<FaceAlienSvg />} text={t('character')} href='/profile?page=edit' />
      ),
    },
    {
      key: 'logout',
      element: (
        <SelectItem icon={<ExitRedSvg />} text={t('logout')} onClick={() => logout()} isExit />
      ),
    },
  ];

  return (
    <Space direction='vertical'>
      <Space wrap>
        <Dropdown
          overlayStyle={{ width: '202px' }}
          dropdownRender={() => {
            return <DropdownPlatform menuItems={menuItems} profileType={profileType} />;
          }}
          placement='bottomLeft'
          trigger={['hover']}>
          <div className={styles.profile}>
            <Avatar
              active={true}
              role={userContext.currentProfile?.profileType}
              size='small'
              image={getUserImageSource(userContext.currentProfile, Preset.smallIconCrop)}
            />
          </div>
        </Dropdown>
      </Space>
    </Space>
  );
};

export default Profile;
